require('./preGrantedCreditStepThree.scss');
require('./preGrantedCreditStepThree.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// components
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
const PreGrantedCreditLegalConfirmation = require('../preGrantedCreditLegalConfirmation/preGrantedCreditLegalConfirmation');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// components cc
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
// constants
const { PRE_GRANTED_CREDIT_PID } = require('constants/gdprPlacementIds');
const { PRE_GRANTED_CREDIT_STANDARD, PRE_GRANTED_CREDIT_SUBTYPE, PRE_GRANTED_CREDIT_TYPE } = require('constants/index');
const { EVIDENCE_OVERDRAFT } = require('constants/flagBasedFeatures');
const {
    CONTRACT_DOCUMENT,
    DEFAULT_VIEWER_HEIGHT,
    INE_DOCUMENT,
    preGrantedCredit: {
        MULTI_OTP_MESSAGE_CODE,
        OPERATION_TYPE,
    },
    SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS,
    YES, NO
} = require('../../../../loansConstants/index');
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations")
// helpers
const { recordGdprClauseInteraction } = require('utilities/consentsHelper');
const { PROC_GDPR_CONSENTS_CONTRACTS, recordLink } = require('utilities/tagging');
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const { getMaskedAccount } = require('../../../../loansUtilities/loansHelper');
const download = require('downloadjs');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class PreGrantedCreditStepThree extends React.Component {

    constructor(props) {
        super(props);

        this.handleCheckboxDownloadEvents = this.handleCheckboxDownloadEvents.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.buildRadioButton = this.buildRadioButton.bind(this);
        this.handleCheckRadioButton = this.handleCheckRadioButton.bind(this);
    }

    componentDidMount() {
        const { getHiringDocuments, getOverdraftInitOne, immPreGrantedCredit } = this.props;
        immPreGrantedCredit.get('initAPIFlag') && getOverdraftInitOne();
        !__CONTACT_CENTER__ && getHiringDocuments();
    }


    handleOnDownloadDocument() {
        const { immPreGrantedCredit } = this.props;
        let document = immPreGrantedCredit.get('fileINEDocument')
        let documentName = "INE_document"

        download(document, documentName, 'application/pdf');
    }

    buildHeader() {
        const { immFlagBasedFeatures } = this.props;
        return (
            <header className="pre-granted-credit-step-three__header">
                <h3>
                    <FormattedText value="contractsView-confirmationLabel" />
                </h3>
            </header>
        );
    }

    buildTinTae() {
        return (
            <span>
                <span className="pre-granted-credit-step-three tin-normal"><FormattedText value="contractsView-tin" /><FormattedText value="contractSummary-pregrantedTIN" /></span>
                &nbsp;
                (<FormattedText value="contractSummary-pregrantedTAE" /> <FormattedText value="contractsView-tae" />)
            </span>
        );
    }

    buildDetails() {
        const { immAccount, immPreGrantedCredit } = this.props;
        const account = getMaskedAccount(immAccount);

        const amount = immPreGrantedCredit.get('selectedAmount');
        const formattedAmount = getFormattedString({
            amount,
            currency: immPreGrantedCredit.get('currency'),
            decimalsLength: decimalsLength(amount)
        });

        const tinTae = this.buildTinTae();

        const fields = [
            {
                title: formatText('contractsView-amountRequested'),
                bodyText: formattedAmount,
                className: 'pre-granted-credit-step-three__important-list-item space-top'
            },
            {
                title: formatText('contractsView-associatedAccount'),
                bodyText: account,
                bodyWordBreak: false,
                information: account,
                icon: 'icon-informacion',
                tooltipPlacement: 'top',
                tooltipOffset: [0, -15],
                className: 'pre-granted-credit-step-three space-top'
            },
            {
                title: formatText('contractsView-tinAndTae'),
                bodyText: tinTae,
                className: 'pre-granted-credit-step-three space-top'
            }
        ];

        const listItems = fields.map((field, index) => (
            <OKInformativeListItem
                key={`item-${index}`}
                {...field}
            />
        ));

        return (
            <OKInformativeList columns={3}>
                {listItems}
            </OKInformativeList>
        );
    }

    buildWarning() {
        return (
            <div className="pre-granted-credit-step-three__warning">
                <FormattedText
                    value="contractsView-preGrantedCreditContractWarningMessage"
                    className="pre-granted-credit-step-three__warning-text"
                />
            </div>
        )
    }

    buildConsents() {
        return (
            <OKConsents
                placementId={PRE_GRANTED_CREDIT_PID}
                handleAcceptAll={this.onGdprAcceptAll}
                handleChangeValue={this.onGdprChangeValue}
                handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
            />
        );
    }

    handleCheckboxDownloadEvents(docType) {
        const { immPreGrantedCredit } = this.props;
        if (docType === INE_DOCUMENT) {
            window.open(immPreGrantedCredit.get('precontractualLink'));
        } else {
            window.open(SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={() => this.handleCheckboxDownloadEvents(docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`pregrantedCreditAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('pregrantedCreditIneDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('pregrantedCreditContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }

    buildViewer() {
        const { immFlagBasedFeatures, immPreGrantedCredit, getHiringDocuments, onAgreeCheckbox, onPrint } = this.props;
        const file = immPreGrantedCredit.get('fileINEDocument');
        const agree = immPreGrantedCredit.get('agree');
        const validate = immPreGrantedCredit.get('agreeError');
        const downloadError = immPreGrantedCredit.get('downloadError');
        const loadingDownload = immPreGrantedCredit.get('isFetchingZip');
        const isLoading = immPreGrantedCredit.get('isFetchingINEDocument');
        const errorLoading = immPreGrantedCredit.get('errorINEDocument');

        const poeditorPrefix = 'contractConfirmationStep';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const checkboxLabel = <FormattedText value={translationContractLoanPdfViewerINE.PDF_CHECKBOX} />;
        const checkboxFlag = immPreGrantedCredit.get('checkboxFlag')
        return !!file ? (
            <ContractLoanPdfViewer
                agreeCheckbox={agree}
                checkboxLabel={checkboxLabel}
                document={file}
                downloadError={downloadError}
                errorLoading={errorLoading}
                getDocuments={getHiringDocuments}
                hasSignaturePattern={__CONTACT_CENTER__ && !isPrintOfficeMode()}
                isLoading={isLoading}
                loadingDownload={loadingDownload}
                onAgreeCheckbox={onAgreeCheckbox}
                onDownload={this.handleOnDownloadDocument}
                onPrint={onPrint}
                title={title}
                validate={validate}
                viewerHeight={DEFAULT_VIEWER_HEIGHT}
                checkboxFlag={checkboxFlag}
            />
        ) : <LoadingSection />;
    }


    buildOtpParams() {
        const { immPreGrantedCredit, immAccount, immFlagBasedFeatures } = this.props;
        const ammount = immPreGrantedCredit.get('selectedAmount');
        const currency = immPreGrantedCredit.get('currency');
        const operationProcessIdPolicy = immPreGrantedCredit.get('operationProcessIdPolicy')
        return immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT) ? {
            ammount,
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immAccount.get('product') + immAccount.get('contractNumber'),
            operationProcessId: operationProcessIdPolicy,
            evidenceType: "SIGN_DOCUMENT"
        } : {
            ammount,
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immAccount.get('product') + immAccount.get('contractNumber')
        };
    }

    buildOtp() {
        const { immPreGrantedCredit, immFlagBasedFeatures } = this.props;
        const agree = !__CONTACT_CENTER__ ? immPreGrantedCredit.get('agree') : __CONTACT_CENTER__ && !isPrintOfficeMode() ? immPreGrantedCredit.get('confirmationCheckbox') : null;
        const params = this.buildOtpParams();

        return agree ? (
            <div className="pre-granted-credit-step-three__otp">
                <GDPRSignaturePattern
                    operationType={OPERATION_TYPE}
                    operationParams={params}
                    multiOTPMessageCode={MULTI_OTP_MESSAGE_CODE}
                />
            </div>
        ) : null;
    }

    buildLegalConfirmation() {
        const { immPreGrantedCredit, immProfile, preContractualMail, requestProfile, resetPrecontractualMail,
            sendPreContractualMail, updateConfirmationCheckbox, immFlagBasedFeatures, sendOverDraftSimpleEmail, getContractDraftDocument } = this.props;

        return (
            <PreGrantedCreditLegalConfirmation
                immPreGrantedCredit={immPreGrantedCredit}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetPrecontractualMail={resetPrecontractualMail}
                sendPreContractualMail={sendPreContractualMail}
                standar={PRE_GRANTED_CREDIT_STANDARD}
                subType={PRE_GRANTED_CREDIT_SUBTYPE}
                type={PRE_GRANTED_CREDIT_TYPE}
                updateConfirmationCheckbox={updateConfirmationCheckbox}
                immFlagBasedFeatures={immFlagBasedFeatures}
                sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
                getContractDraftDocument={getContractDraftDocument}
            />
        );
    }

    onGdprAcceptAll(value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS)
    }

    onGdprChangeValue(id, value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const linkElement = event.target;

        if (linkElement) {
            recordLink(PROC_GDPR_CONSENTS_CONTRACTS, get(linkElement, 'attributes.data-title.value', ''));
        }
    }
    buildPreContractLegalInfoText() {
        return (
            <div className="pre-contractual-mail__legaltextview">
                <OKMessage type="informative">
                    <FormattedText value="contractsView-preContractualStep3LegalInfoText" />
                </OKMessage>
            </div>
        )
    }

    handleCheckRadioButton(check) {
        const { checkRadioButtonOfficeStepThree } = this.props;
        checkRadioButtonOfficeStepThree(check === YES)
    }

    buildRadioButton() {
        const { immPreGrantedCredit } = this.props;
        const officePrintStepThree = immPreGrantedCredit.get('officePrintStepThree');
        const documentSignedRadioButton = immPreGrantedCredit.get('documentSignedRadioButtonStepThree');

        return (
            officePrintStepThree &&
            <div className="mortgage-request-holder-radio-button">
                <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
                <RadioButtonGroup
                    onChange={this.handleCheckRadioButton}
                    selectedValue={documentSignedRadioButton === null ? '' : documentSignedRadioButton ? YES : NO}
                    idPrefix="newRadioPrintedDocument"
                    isHorizontal={false}
                    name="newRadioPrintedDocument">
                    <RadioButton label={formatText('officePrinter-yesRadioOption')} value={YES} className="signature-pattern__printed-documents-radio" />
                    <RadioButton label={formatText('officePrinter-noRadioOption')} value={NO} className="signature-pattern__printed-documents-radio" />
                </RadioButtonGroup>
            </div>
        )
    }

    render() {
        const { immFlagBasedFeatures, immPreGrantedCredit } = this.props;
        const header = this.buildHeader();
        const confirmationScript1 = __CONTACT_CENTER__ && !isPrintOfficeMode() && (<ConfirmationScript isOverDraft operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />);
        const confirmationScript2 = __CONTACT_CENTER__ && !isPrintOfficeMode() && (<ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />);
        const warning = this.buildWarning();
        const details = (__CONTACT_CENTER__ && !isPrintOfficeMode()) && this.buildDetails();
        const consents = (__CONTACT_CENTER__ && !isPrintOfficeMode()) && this.buildConsents();
        const viewer = (!__CONTACT_CENTER__) || isPrintOfficeMode() ? this.buildViewer() : null;
        const successDraftDocument = immPreGrantedCredit.get('successDraftDocument');
        const otp = __CONTACT_CENTER__ ? this.buildOtp() : successDraftDocument ? this.buildOtp() : null;
        const isContactCenterWithOverdraftProtection = (__CONTACT_CENTER__ && !isPrintOfficeMode());
        const documentViewSection = isContactCenterWithOverdraftProtection ? this.buildLegalConfirmation() : null;
        const operative = formatText('operatives-loansAndMortgageHire_preGrantedCredit');
        const preGrantedCreditCCFlag = !!(__CONTACT_CENTER__ && !isPrintOfficeMode());
        const preContractLegalInfoBlock = preGrantedCreditCCFlag && this.buildPreContractLegalInfoText();
        return (
            <article className="pre-granted-credit-step-three">
                {header}
                <section className="pre-granted-credit-step-three__section">
                    {confirmationScript1}
                    {warning}
                    {(__CONTACT_CENTER__ && !isPrintOfficeMode()) &&
                        <BlockInfo>
                            <FormattedText value={'contractsView-preGrantedCreditContractCCMessage1'} />
                        </BlockInfo>
                    }
                    {details}
                    {preContractLegalInfoBlock}
                    {isPrintOfficeMode() &&
                        <BlockInfo>
                            <FormattedText value={'contractsView-preGrantedCreditContractOfficeMessage'} />
                        </BlockInfo>
                    }
                    {consents}
                    {viewer}
                </section>
                {confirmationScript2}
                {documentViewSection}
                {(__CONTACT_CENTER__ && !isPrintOfficeMode()) &&
                    <div className="pre-contractual-mail__information">
                        <i className="icon-informacion"></i>
                        <FormattedText value={'contractsView-preGrantedCreditContractCCMessage2'} />
                    </div>
                }
                {this.buildRadioButton()}
                {otp}
            </article>
        );
    }
}

PreGrantedCreditStepThree.propTypes = {
    getHiringDocuments: PropTypes.func.isRequired,
    getOverdraftInitOne: PropTypes.func.isRequired,
    immAccount: PropTypes.object,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    sendOverDraftSimpleEmail: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
    checkRadioButtonOfficeStepThree: PropTypes.func.isRequired,
};

module.exports = PreGrantedCreditStepThree;
